/**
 * GMDSS Equipment Guidance - SIMPLIFIED DIRECT SYSTEM
 * Every requirement ID maps directly to guidance - NO MAPPINGS, NO COMPLEXITY
 * Based on comprehensive WBC3 verification by Regulations Assistant
 */

import { GMDSS_SIMPLE_GUIDANCE, getGMDSSSimpleGuidance } from './gmdss.simple.js';

/**
 * Simple Direct GMDSS Guidance - NO MAPPINGS
 * @param {string} itemId - Equipment requirement ID
 * @returns {Object|null} Guidance object or null
 */
export function getGMDSSGuidance(itemId) {
  return getGMDSSSimpleGuidance(itemId);
}

// Export the guidance object for compatibility
export { GMDSS_SIMPLE_GUIDANCE as GMDSS_GUIDANCE };